// ToastContainer.tsx
import clsx from "clsx";
import { Toast } from "./index";

const positionClasses = {
  "top-left": "top-4 left-4 items-start",
  "top-center": "top-4 left-1/2 -translate-x-1/2 items-center",
  "top-right": "top-4 right-4 items-end",
  "bottom-left": "bottom-4 left-4 items-start",
  "bottom-center": "bottom-4 left-1/2 -translate-x-1/2 items-center",
  "bottom-right": "bottom-4 right-4 items-end",
};

interface Props {
  toasts: ToastItem[];
  onRemove: (id: string) => void;
}

export const ToastContainer: React.FC<Props> = ({ toasts, onRemove }) => {
  const grouped = toasts.reduce<Record<string, ToastItem[]>>((acc, toast) => {
    const pos = toast.position || "top-right";
    acc[pos] = acc[pos] || [];
    acc[pos].push(toast);
    return acc;
  }, {});

  return (
    <>
      {Object.entries(grouped).map(([position, items]) => (
        <div
          key={position}
          className={clsx(
            "fixed z-50 flex flex-col gap-3",
            positionClasses[position as keyof typeof positionClasses],
          )}
        >
          {items.map((toast) => (
            <Toast key={toast.id} toast={toast} onRemove={onRemove} />
          ))}
        </div>
      ))}
    </>
  );
};
